import { mapState } from 'vuex';

import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';

export default {
  components: {
    codemirror,
  },
  data: function () {
    return {
      cmLineNumbers: false,
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    cmOptions() {
      return {
        tabSize: 4,
        mode: { name: 'javascript', json: true },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false,
        },
        lineWrapping: false,
      };
    },
  },
  methods: {
    onCmFocus() {
      this.cmLineNumbers = true;
    },
  },
};
